export type MediaType = 'YOUTUBE' | 'IMAGE' | 'AUDIO' | 'VIDEO';

export interface MediaContent {
    id: string;
    type: MediaType;
    url: string;
    startTime?: number; // For YouTube clips, in seconds
    endTime?: number; // For YouTube clips, in seconds
    title: string;
    description?: string;
}

export interface YouTubeClip extends MediaContent {
    type: 'YOUTUBE';
    url: string;
    title: string;
    description?: string;
    startTime?: number;
    endTime?: number;
    autoplay?: boolean;
    showControls?: boolean;
    loop?: boolean;
    correctAnswerAudioStartTime?: number;
    correctAnswerAudioEndTime?: number;
}

export class MediaContentImpl implements MediaContent {
    constructor(
        public id: string,
        public type: MediaType,
        public url: string,
        public title: string,
        public description?: string,
        public startTime?: number,
        public endTime?: number
    ) {}

    static createYouTubeClip(
        id: string,
        url: string,
        title: string,
        startTime?: number,
        endTime?: number,
        description?: string,
        correctAnswerAudioStartTime?: number,
        autoplay: boolean = false,
        showControls: boolean = true,
        loop: boolean = false
    ): YouTubeClip {
        return {
            id,
            type: 'YOUTUBE',
            url,
            title,
            startTime,
            endTime,
            description,
            correctAnswerAudioStartTime,
            autoplay,
            showControls,
            loop
        };
    }
} 